import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPanelSplit = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.25 2.25H3.75C2.64543 2.25 1.75 3.14543 1.75 4.25V9.75C1.75 10.8546 2.64543 11.75 3.75 11.75H10.25C11.3546 11.75 12.25 10.8546 12.25 9.75V4.25C12.25 3.14543 11.3546 2.25 10.25 2.25Z",
		stroke: "currentColor",
		strokeWidth: 1.17
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.1 2.5V11.5",
		stroke: "currentColor",
		strokeWidth: 1.17
	})]
});
export default SvgPanelSplit;
